var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !this.isPopFrame
    ? _c("div", { staticClass: "login_footer" }, [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t("newDategetfullyearShuYiKeJiBanQuanSuoYou", [
                new Date().getFullYear(),
              ])
            ) + " "
          ),
        ]),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("beiAnHaoShuIcpBei_14015776Hao_2")) +
              "蜀ICP备14015776号-2"
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }